import { render, staticRenderFns } from "./RightOrderDetailService.vue?vue&type=template&id=a3f35bee&"
import script from "./RightOrderDetailService.vue?vue&type=script&lang=ts&"
export * from "./RightOrderDetailService.vue?vue&type=script&lang=ts&"
import style0 from "./RightOrderDetailService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports